export function importCodes(value: string) {
  return value
    .split(/[,\n]/)
    .map((v) => v.trim())
    .filter(Boolean);
}
export function importPollingInterval(status: string | undefined, started: number, now = Date.now()): number | false {
  return status && ['queued', 'claimed', 'retryable_failed'].includes(status) && now - started < 600000 ? 5000 : false;
}
export function newSelectionPayload(
  kind: 'place-mappings' | 'hotel-memberships',
  geo: string,
  target: string,
  enabled: boolean,
  reason: string,
  rank = 0,
) {
  if (
    !geo ||
    !target ||
    !reason.trim() ||
    reason.trim().length > 512 ||
    !Number.isSafeInteger(rank) ||
    rank < 0 ||
    rank > 2147483647
  )
    throw new Error('Invalid new selection');
  return {
    geo_place_id: geo,
    enabled,
    reason: reason.trim(),
    expected_version: 0,
    ...(kind === 'place-mappings' ? { source: 'ubikeishon', place_id: target } : { hotel_id: target, rank }),
  };
}
